/**
 * @generated SignedSource<<f25d7ebf2dc319af4edfb41f7c044e73>>
 * @relayHash 89b7016f5a808f629c16921522ca92ce
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 89b7016f5a808f629c16921522ca92ce

import { ConcreteRequest } from 'relay-runtime';
export type useCallTranscriptSubscriptionChSubscription$variables = {
  appointmentId: string;
};
export type useCallTranscriptSubscriptionChSubscription$data = {
  readonly ch_onCallTranscriptUpdated: {
    readonly callTranscriptEndedAt: string;
    readonly id: string;
    readonly transcript: ReadonlyArray<{
      readonly id: string;
      readonly text: string;
    }>;
  };
};
export type useCallTranscriptSubscriptionChSubscription = {
  response: useCallTranscriptSubscriptionChSubscription$data;
  variables: useCallTranscriptSubscriptionChSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "CallTranscript",
    "kind": "LinkedField",
    "name": "ch_onCallTranscriptUpdated",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "TranscriptEntry",
        "kind": "LinkedField",
        "name": "transcript",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "callTranscriptEndedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallTranscriptSubscriptionChSubscription",
    "selections": (v2/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallTranscriptSubscriptionChSubscription",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "89b7016f5a808f629c16921522ca92ce",
    "metadata": {},
    "name": "useCallTranscriptSubscriptionChSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "cc61d19beece9e353fcdc3da3b84d9f0";

export default node;
